import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const BackToTopButton = () => {
  const [backToTop, setBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setBackToTop(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollUP = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    backToTop && (
      <button
        className="fixed bottom-12 w-10 h-10 bg-primary text-white border-2 border-zinc-400/40 p-2 rounded-full flex justify-center items-center transition-transform duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] hover:translate-y-[-5px] 
    left-1/2 -translate-x-1/2 lg:left-auto lg:right-20 lg:translate-x-0 lg:bottom-20 text-2xl"
        onClick={scrollUP}
      >
        <FontAwesomeIcon icon={faArrowUp} className="text-[16px]" />
      </button>
    )
  );
};

export default BackToTopButton;
